import { useEffect } from 'react';
import { map, without } from 'lodash';

import { isToolExcludedFromSuggestedPersonas } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { CustomerPersonaStore } from 'src/store';
import { MainStore, useDocumentViewActions } from 'src/views/ProjectDocumentView/store';

const useCustomerPersonaState = createStateSelectorHook(CustomerPersonaStore, [
  'suggestedCustomerPersonas',
  'suggestedCustomerPersonasSeenIds',
]);

const useMainState = createStateSelectorHook(MainStore, ['generationTool']);

export const useSetHasHiddenSuggestedPersonas = (visiblePersonas) => {
  const documentActions = useDocumentViewActions();

  const { suggestedCustomerPersonas, suggestedCustomerPersonasSeenIds } = useCustomerPersonaState();
  const { generationTool } = useMainState();
  const toolExcluded = isToolExcludedFromSuggestedPersonas(generationTool);
  const toolIsSelected = Boolean(generationTool);

  useEffect(() => {
    if (toolExcluded || !toolIsSelected) {
      documentActions.setHasHiddenSuggestedPersonas(false);
      return;
    }

    const suggestedIds = map(suggestedCustomerPersonas, 'id');
    const hasHiddenSuggested =
      without(suggestedIds, ...suggestedCustomerPersonasSeenIds).length > 0;

    documentActions.setHasHiddenSuggestedPersonas(hasHiddenSuggested);
  }, [
    suggestedCustomerPersonas,
    suggestedCustomerPersonasSeenIds,
    visiblePersonas,
    documentActions,
    toolExcluded,
    toolIsSelected,
  ]);
};
